import React, { useEffect, useState } from "react";
import { UTILS } from "../../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { TbFileTypeZip } from "react-icons/tb";
import { BsFiletypeDoc } from "react-icons/bs";
import { GrDocumentPdf } from "react-icons/gr";
import { GrDocumentTxt } from "react-icons/gr";
import { PiFilePptLight } from "react-icons/pi";
import { BsFiletypePptx } from "react-icons/bs";
import { BsFiletypeXls } from "react-icons/bs";
import { BsFiletypeXlsx } from "react-icons/bs";
// import ReactFancyBox from 'react-fancybox';
// import 'react-fancybox/lib/fancybox.css';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { useDispatch } from "react-redux";
import { setNewComment } from "../../../redux/featuers/NewCommentSlice";

export const AttachmentSection = ({
  setAttachmentsFile,
  attachmentsFile,
  cardDetail,
  setShowCover,
  handleCommentdata,
  handleFileCoverChange
}) => {
  // console.log('AttachmentSection', attachmentsFile);
  const [show, setShow] = useState(false);
  const [getattachemtID, setgetattachemtID] = useState(null);
  const [getEditor, setEditor] = useState(null);
  const [getcomment, setcomment] = useState(null);
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setgetattachemtID(id);
  };

  const dispatchItem = useDispatch();
  const onPressDeleteAttachment = async (attachmentId) => {
    // console.log('onPressDeleteAttachment', data.id);
    // console.log('onPressTaskID', taskData.id);
    // console.log("attachmentId", attachmentId);
    // console.log("attachmentsFile?.id",cardDetail?.id);
    try {
      const formData = new FormData();
      formData.append("task_id", cardDetail?.id);
      formData.append("attachment_id", attachmentId);
      const randomString = Math.random().toString(36).substring(2, 5);

      const response = await axios.post(
        `${UTILS.API_url}board/v1/board-list-cards/attachment/delete?${randomString}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log('Attachement deleted succcesfully', response);

      if (response.status == 200) {
        // console.log("response", response.data.attachments);
        toast.success(response.data.success);
        setAttachmentsFile([...response.data.attachments]);
        handleClose();
      }
    } catch (error) {
      console.error("Error updating title", error);
    }
  };

  const [showAll, setShowAll] = useState(false);
  const MIN_ATTACHMENTS = 4;

  const handleToggleShowAll = () => {
    setShowAll(!showAll);
  };
  const attachmentsToDisplay = showAll
    ? attachmentsFile
    : attachmentsFile.slice(0, MIN_ATTACHMENTS);
  // console.log("attachmentsToDisplay", attachmentsFile,attachmentsToDisplay);

  const handleDownload = async (urls,file_name) => {
    window.href.location= 'https://trelloassets.tgcrm.net/downloadassets.php?url='+urls+'&filename='+file_name;
    const downloadUrl = 'https://trelloassets.tgcrm.net/downloadassets.php?url=' + encodeURIComponent(urls) + '&filename=' + encodeURIComponent(file_name);

    // Open the download URL in a new tab
    window.open(downloadUrl, '_blank');
    // console.log('id', id);

    // Filter the attachment by id
    // const attachment = attachmentsToDisplay.find((att) => att.id == id);
    // // console.log('attachment', attachment);

    // if (attachment) {
    //   try {
    //     // Fetch the file as a Blob
    //     const response = await fetch(attachment.file_path);
    //     const blob = await response.blob();

    //     // Create a temporary URL for the Blob
    //     const url = window.URL.createObjectURL(blob);

    //     // Create a link element and trigger the download
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.download = attachment.original_name || attachment.file_name;
    //     link.click();

    //     // Clean up the temporary URL
    //     window.URL.revokeObjectURL(url);
    //   } catch (error) {
    //     console.error("Download failed", error);
    //   }
    // } else {
    //   console.error("Attachment not found");
    // }
  };

  const handleSetCoverImage = async (file, id) => {
    // console.log("file",file,id);

    const formData = new FormData();
    formData.append("task_id", cardDetail?.id);
    formData.append("attachment_id", id);

    try {
      const response = await axios.post(
        `${UTILS.API_url}board/v1/board-list-cards/cover-image/attachment-as-cover-image`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log('Response:setShowCover', response);
      console.log("responseresponse",response);
      handleFileCoverChange(response.data.board_list_card);
      setShowCover((prevState) => ({
        ...prevState,
        cover_image: file, // Update only the cover_image
      }));
    } catch (error) {
      // console.error('Error updating cover image:', error);
    }
  };
  const handleSetComment = async (file,url) => {
    const tag = `<a class="tag_data" href="${url}"><span class="tag_user" contenteditable="false">#${file}</span></a>`;
    
    // Ensure you're getting the latest comment value before updating
    console.log("adding comment ---> ",tag);
    const currentComment = getcomment || ''; // Use existing comment or an empty string
    dispatchItem(
      setNewComment(tag.toString())
    )
    // console.log('current comment---> ',currentComment);
  
    // Append the new tag to the previous comment
    setcomment(`${currentComment} ${tag}`); // Add space for readability
    
    // Call the handler with the new tag

    handleCommentdata(tag.toString());
  };
  
  
  // let uploadAttachmentCover=(path, id) =>{
  //   let makePath=[
  //     {
  //       id:id,
  //       file_path:path
  //     }
  //   ];
  //   console.log("makePath",makePath);

  //   setCoverAttachment(makePath);

  // }

  const isRecent = (createdAt, limitInMinutes) => {
    // Check if createdAt is defined and is a string
    if (typeof createdAt !== 'string') return false;

    const currentTime = new Date();
    let timeDiffInMillis;

    if (createdAt.includes('second')) {
        const seconds = parseInt(createdAt.split(' ')[0], 10);
        timeDiffInMillis = seconds * 1000; // Convert seconds to milliseconds
    } else if (createdAt.includes('minute')) {
        const minutes = parseInt(createdAt.split(' ')[0], 10);
        timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
    } else {
      const minutes = 50;
        timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
        // return false; // Return false if the format isn't recognized
    }

    const createdTime = new Date(currentTime.getTime() - timeDiffInMillis);
    const differenceInMillis = currentTime - createdTime;

    return differenceInMillis > limitInMinutes * 60 * 1000; // Convert limit to milliseconds
};


  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {});

    return () => {
      Fancybox.unbind('[data-fancybox="gallery"]');
    };
  }, []);

  return (
    <div>
      {attachmentsFile && attachmentsFile.length > 0 && (
        <div className="des-div-flex">
          <h4 class="description-heading">
            <span class="material-symbols-outlined attac-icon lg-icon">
              attach_file
            </span>
            Attachments
          </h4>
          {attachmentsToDisplay && attachmentsToDisplay.length >= 4 ? (
            <button
              className="btn btn-light att-add"
              onClick={handleToggleShowAll}
            >
              {showAll
                ? "Hide Attachments"
                : `View all Attachments (${attachmentsFile.length - 4} Hidden)`}
            </button>
          ) : (
            ""
          )}
        </div>
      )}

      {attachmentsFile && attachmentsFile.length > 0 ? (
        <>
          {attachmentsToDisplay.map((value, index) => (
            <div key={index} className="attachment-div">
              <a
                title={value?.original_name}
                className="attachment-thumbnail"
                href={
                  isRecent(value?.created_at , 10)
                  ? UTILS.images_url + "original/" + value?.file_name
                  : UTILS.temp_image_url + "original/" + value?.file_name
                }
                // href={UTILS.images_url + "original/" + value?.file_name}
                data-fancybox="gallery"
              >
                <span className="att-name">
                  {value?.mime_type === "application/zip" && (
                    <TbFileTypeZip size={24} />
                  )}
                  {(value?.mime_type === "application/msword" ||
                    value?.mime_type ===
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && (
                    <BsFiletypeDoc size={24} />
                  )}
                  {value?.mime_type === "application/pdf" && (
                    <GrDocumentPdf size={24} />
                  )}
                  {value?.mime_type === "text/plain" && (
                    <GrDocumentTxt size={24} />
                  )}
                  {(value?.mime_type === "application/vnd.ms-powerpoint" ||
                    value?.mime_type ===
                      "application/vnd.openxmlformats-officedocument.presentationml.presentation") && (
                    <PiFilePptLight size={24} />
                  )}
                  {(value?.mime_type === "application/vnd.ms-excel" ||
                    value?.mime_type ===
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (
                    <BsFiletypeXls size={24} />
                  )}
                  {value?.mime_type.startsWith("image/") && (
                    // <ReactFancyBox
                    //   title={value?.original_name}
                    //   thumbnail={
                    //     UTILS.images_url + '150x150/' + value?.file_name
                    //   }
                    //   image={UTILS.images_url + '150x150/' + value?.file_name}
                    //   alt={value?.original_name}
                    //   className="image-preview"
                    // />
                    <img
                      // src={
                      //   isRecent(value?.created_at , 10)
                      //   ? UTILS.images_url + "150x150/" + value?.file_name
                      //   : UTILS.temp_image_url + "150x150/" + value?.file_name
                      // }
                      src={
                            isRecent(value?.created_at, 10)
                              ? UTILS.images_url +
                                (value?.file_name?.toLowerCase().endsWith('.gif') ? 'original/' : '150x150/') +
                                value?.file_name
                              : UTILS.temp_image_url +
                                (value?.file_name?.toLowerCase().endsWith('.gif') ? 'original/' : '150x150/') +
                                value?.file_name
                          }
                      alt={value?.original_name}
                      className="image-preview"
                    />
                  )}
                </span>
              </a>
              
              <div className="attachment-thumbnail-detail">
                <h6 className="attachment-file-name">{value?.original_name}</h6>
                <span className="attatchment-time">{value?.created_at}</span>
                <span className="attatchment-link">
                {!cardDetail?.deleted_at && (
                  <a
                    onClick={() => handleShow(value?.id)}
                    href="javascript:;"
                    className="delete-attachment"
                  >
                    Delete
                  </a>)}
                </span>
                <span className="attatchment-link">
                {!cardDetail?.deleted_at && (
                  <a
                    target="_blank"
                    // onClick={() => handleDownload(value?.id)}
                    href={
                      'https://trelloassets.tgcrm.net/downloadassets.php?url=' +
                      (isRecent(value?.created_at , 10)
                      ? UTILS.images_url + "original/" + value?.file_name
                      : UTILS.temp_image_url + "original/" + value?.file_name)+'&filename='+encodeURIComponent(value?.original_name)
                    }
                    // href={UTILS.images_url + "original/" + value?.file_name}
                    className={
                      value?.mime_type.startsWith("image/")
                        ? "attachment-link"
                        : "download-attachment"
                    }
                    download={value?.original_name}
                  >
                    Download
                  </a>)}
                </span>

                {/* <span className="attatchment-link">
                  <a
                    onClick={() =>
                      handleSetCoverImage(value?.file_path, value?.id)
                    }
                    href="javascript:void(0);"
                    className="delete-attachment"
                  >
                    Make Cover
                  </a>
                </span> */}

                {value?.mime_type.startsWith("image/") && (
                  <span className="attatchment-link">
                  {!cardDetail?.deleted_at && (
                    <a
                      onClick={() =>
                        handleSetCoverImage(value?.file_path, value?.id)
                      }
                      href="javascript:void(0);"
                      className="delete-attachment"
                    >
                      Make Cover
                    </a>)}
                  </span>
                )}
                {<span className="attatchment-link">
                  {!cardDetail?.deleted_at && (
                    <a
                      onClick={() =>
                        handleSetComment(value?.original_name,'https://trelloassets.tgcrm.net/downloadassets.php?url=' +
                      (isRecent(value?.created_at , 10)
                      ? UTILS.images_url + "original/" + value?.file_name
                      : UTILS.temp_image_url + "original/" + value?.file_name)+'&filename='+encodeURIComponent(value?.original_name))
                      }
                      href="javascript:void(0);"
                      className="delete-attachment"
                    >
                      Comment
                    </a>)}
                  </span>
                }
              </div>
            </div>
          ))}
        </>
      ) : (
        ""
      )}
      <Modal className="deleteModal" show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="modalHead">
            <span class="material-symbols-outlined">warning</span>
            {/* <h4>Are You Sure ?</h4> */}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>Are you sure you want to delete this file.</Modal.Title>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => onPressDeleteAttachment(getattachemtID)}
            style={{ backgroundColor: "red", color: "white", border: "none" }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
